import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useForm from 'react-hook-form';
import InputMask from 'react-input-mask';
import DatePicker, { registerLocale } from 'react-datepicker';
/* actions */
import { getAllDepartments } from '../../redux/actions/departments';
import { addExpedients } from '../../redux/actions/expedients';
/* components */
import ErrorMsgField from '../../components/ErrorMsgField';
import AlertMsg from '../../components/AlertMsg';
import FormFooter from '../../components/FormFooter';
import FormHeader from '../../components/FormHeader';
/* form-validation */
import schema from '../../form-validation/expedient';
/* utils */
import handleChangeDefault from '../../utils/handleChangeDefault';
/* others */
import {
  dayOfWeekFields,
  INITIAL_VALUES_INPUT_MASK,
  hourRegex,
  dateRegex
} from './configFields';
import ptBR from 'date-fns/locale/pt-BR';
registerLocale('ptBR', ptBR);

function Add () {
  const INITIAL_VALUES = {
    name: '',
    department: '',
    week: [
      {
        start: 0,
        end: 0,
        day: 0
      },
      {
        start: 0,
        end: 0,
        day: 1
      },
      {
        start: 0,
        end: 0,
        day: 2
      },
      {
        start: 0,
        end: 0,
        day: 3
      },
      {
        start: 0,
        end: 0,
        day: 4
      },
      {
        start: 0,
        end: 0,
        day: 5
      },
      {
        start: 0,
        end: 0,
        day: 6
      }
    ],
    recess: []
  };
  const dispatch = useDispatch();
  const submitButton = useRef();
  const { register, handleSubmit, errors, reset, setError, setValue } = useForm(
    {
      validationSchema: schema,
      reValidateMode: 'onSubmit'
    }
  );
  const departments = useSelector(state => state.departments);
  const expedients = useSelector(state => state.expedients);
  const [data, setData] = useState(INITIAL_VALUES);
  const [inputMask, setInputMask] = useState(INITIAL_VALUES_INPUT_MASK);
  const [recessInputs, setRecessInputs] = useState([]);

  useEffect(() => {
    dispatch(getAllDepartments());
  }, [dispatch]);

  const submit = () => {
    const resetForm = () => {
      reset();
      setData({ ...INITIAL_VALUES });
      setInputMask({ ...INITIAL_VALUES_INPUT_MASK });
      setRecessInputs([]);
    };

    let permitSubmitForm = true;
    const fieldsHour = document.getElementsByClassName('input-hour');
    for (let i = 0; i < fieldsHour.length; i++) {
      let hourValid = true;
      const field = fieldsHour[i];
      const name = field.getAttribute('name-error');
      const { value } = field;

      if (!hourRegex.test(value)) {
        setError(name, 'hour', 'Invalid hour');
        setValue({ [name]: value });
        hourValid = false;
        permitSubmitForm = false;
      }

      if (i % 2 && hourValid) {
        const fieldStartHour = fieldsHour[i - 1];
        const fieldEndHour = fieldsHour[i];
        const startValue = fieldStartHour.value.replace(/:|_/g, '');
        const endValue = fieldEndHour.value.replace(/:|_/g, '');
        if (parseInt(startValue, 10) >= parseInt(endValue, 10)) {
          setError(name, 'endHour', 'Invalid end hour');
          setValue({ [name]: value });
          permitSubmitForm = false;
        }
      }
    }

    const fieldsDate = document.getElementsByClassName('input-date');
    for (const field of fieldsDate) {
      const { value, name } = field;

      if (!dateRegex.test(value)) {
        setError(name, 'date', 'Invalid date');
        setValue({ [name]: value });
        permitSubmitForm = false;
      }
    }

    if (permitSubmitForm) {
      dispatch(addExpedients(data, resetForm, submitButton.current));
    }
  };

  const handleChangeDayOfWeek = (evt, weekPosition, key) => {
    evt.preventDefault();
    const { week } = data;
    const value = evt.target.value.replace(/:|_/g, '');
    const { name } = evt.target;
    setInputMask({ ...inputMask, [name]: evt.target.value });
    if (value && value.length >= 4) {
      week[weekPosition][key] = parseInt(value, 10);
      setData({ ...data, week });
    }
  };

  const handleClickAddRecess = () => {
    const recess = [...recessInputs];
    const date = new Date();
    recess.push({ date, start: '00:00', end: '00:00' });
    setRecessInputs([...recess]);
    const newRecessData = [...data.recess];
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const newDate = `${year}${month > 9 ? month : '0' + month}${
      day > 9 ? day : '0' + day
    }`;
    newRecessData.push({ date: newDate, start: 0, end: 0 });
    setData({ ...data, recess: newRecessData });
  };

  const handleClickRemoveRecess = position => {
    const recess = [...recessInputs];
    recess.splice(position, 1);
    setRecessInputs([...recess]);
    const newRecessData = [...data.recess];
    newRecessData.splice(position, 1);
    setData({ ...data, recess: newRecessData });
  };

  const handleChangeRecess = (evt, position, type) => {
    const recess = [...recessInputs];
    const { value } = evt.target;
    const name = evt.target.name.split('_')[0];
    recess[position][name] = value;
    setRecessInputs([...recess]);
    const newRecessData = [...data.recess];
    if (type === 'hour') {
      const newValue = parseInt(value.replace(/:|_/g, ''), 10);
      newRecessData[position][name] = newValue || 0;
    } else {
      value
        ? setError(evt.target.name)
        : setError(evt.target.name, 'date', 'Invalid date');
      setValue({ [evt.target.name]: value });

      if (value) {
        const date = value;
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        const newDate = `${year}${month > 9 ? month : '0' + month}${
          day > 9 ? day : '0' + day
        }`;
        newRecessData[position][name] = newDate;
      }
    }
    setData({ ...data, recess: newRecessData });
  };

  const handleBlurRecessHour = evt => {
    const name = evt.target.getAttribute('name-error');
    const { value } = evt.target;
    hourRegex.test(value)
      ? setError(name)
      : setError(name, 'hour', 'Invalid hour');
    setValue({ [name]: value });
  };

  return (
    <div className="container-fluid">
      {expedients.addSuccess && (
        <AlertMsg type="success" msg="Expediente cadastrado com sucesso" />
      )}
      {expedients.errorContent &&
        !expedients.errorContent.message.includes('400') &&
        expedients.addError && (
        <AlertMsg type="danger" msg="Falha durante cadastro do expediente" />
      )}
      {expedients.errorContent &&
        expedients.errorContent.message.includes('400') &&
        expedients.addError && (
        <AlertMsg
          type="danger"
          msg="Um expediente com o nome informado já está cadastrado"
        />
      )}
      {!expedients.addSuccess && !expedients.addError && (
        <AlertMsg type="info" msg="Área cadastro de expedientes" />
      )}
      <FormHeader title="Cadastrar Expediente" />
      <form onSubmit={handleSubmit(submit)}>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="name">
                Nome<span className="field-required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="name"
                name="name"
                autoComplete="off"
                value={data.name}
                onChange={evt => handleChangeDefault(evt, data, setData)}
                ref={register}
              />
              {errors.name && errors.name.type === 'required' && (
                <ErrorMsgField type="required" />
              )}
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="department">
                Departamento<span className="field-required">*</span>
              </label>
              <select
                className="form-control"
                id="department"
                name="department"
                value={data.department}
                onChange={evt => handleChangeDefault(evt, data, setData)}
                ref={register}
              >
                <option value="">-- Selecione --</option>
                {departments.data.map((dpt, i) => {
                  const _id = dpt._id || Date.now() + '' + i;
                  return (
                    <option key={_id} value={_id}>
                      {dpt.name}
                    </option>
                  );
                })}
              </select>
              {errors.department && errors.department.type === 'required' && (
                <ErrorMsgField type="required" />
              )}
            </div>
          </div>
        </div>
        {dayOfWeekFields.map((dayOfWeek, position) => {
          return (
            <div
              className="row"
              key={position}
              style={{ backgroundColor: position % 2 === 0 ? '#ddd' : '#fff' }}
            >
              <div className="col-sm-6 mt-1">
                <div className="form-group">
                  <label htmlFor={dayOfWeek[1]}>
                    {dayOfWeek[0]} Horário Abertura
                    <span className="field-required">*</span>
                  </label>
                  <InputMask
                    name={dayOfWeek[1]}
                    mask="99:99"
                    value={inputMask[dayOfWeek[1]]}
                    className="form-control"
                    placeholder="HH:mm"
                    onChange={evt =>
                      handleChangeDayOfWeek(evt, position, 'start')
                    }
                    ref={register}
                  />
                  {errors[dayOfWeek[1]] &&
                    errors[dayOfWeek[1]].type === 'hour' && (
                    <ErrorMsgField type="hour" />
                  )}
                </div>
              </div>
              <div className="col-sm-6 mt-1">
                <div className="form-group">
                  <label htmlFor={dayOfWeek[2]}>
                    {dayOfWeek[0]} Horário Fechamento
                    <span className="field-required">*</span>
                  </label>
                  <InputMask
                    name={dayOfWeek[2]}
                    mask="99:99"
                    value={inputMask[dayOfWeek[2]]}
                    className="form-control"
                    placeholder="HH:mm"
                    onChange={evt =>
                      handleChangeDayOfWeek(evt, position, 'end')
                    }
                    ref={register}
                  />
                  {errors[dayOfWeek[2]] &&
                    errors[dayOfWeek[2]].type === 'hour' && (
                    <ErrorMsgField type="hour" />
                  )}
                  {errors[dayOfWeek[2]] &&
                    errors[dayOfWeek[2]].type === 'endHour' && (
                    <ErrorMsgField type="endHour" />
                  )}
                </div>
              </div>
            </div>
          );
        })}
        <div className="row">
          <div className="container-fluid">
            <div className="form-group">
              <button
                type="button"
                className="btn btn-dark mt-3"
                onClick={handleClickAddRecess}
              >
                <i className="fa fa-plus"></i>&nbsp; Adicionar Recesso
              </button>
            </div>
            {recessInputs.map((recess, position) => {
              return (
                <div
                  className="form-group p-2"
                  key={position}
                  style={{
                    backgroundColor: position % 2 === 0 ? '#eee' : '#fff'
                  }}
                >
                  <div className="form-row align-items-center">
                    <div className="form-group col-sm-3 mb-0">
                      <label>
                        <i className="fa fa-calendar-alt" />
                        &nbsp;{position + 1}&deg; Recesso
                        <span className="field-required">*</span>
                      </label>
                      <DatePicker
                        className="form-control input-date"
                        name={`date_${position}`}
                        onChange={date =>
                          handleChangeRecess(
                            {
                              target: { value: date, name: `date_${position}` }
                            },
                            position,
                            'date'
                          )
                        }
                        selected={recess.date}
                        placeholderText="dd/MM/yyyy"
                        locale="ptBR"
                        dateFormat="dd/MM/yyyy"
                      />
                      {errors[`date_${position}`] &&
                        errors[`date_${position}`].type === 'date' && (
                        <ErrorMsgField type="date" />
                      )}
                      {errors[`date_${position}`] &&
                        errors[`date_${position}`].type === 'repeat' && (
                        <ErrorMsgField type="repeat" />
                      )}
                      {(!errors[`date_${position}`] ||
                        (errors[`date_${position}`] &&
                          errors[`date_${position}`].type === '')) && (
                        <small className="form-text m-0">&nbsp;</small>
                      )}
                    </div>
                    <div className="form-group col-sm-3 mb-0">
                      <label>
                        <i className="far fa-clock" /> Abertura
                        <span className="field-required">*</span>
                      </label>
                      <InputMask
                        name="start"
                        mask="99:99"
                        value={recess.start}
                        className="form-control input-hour"
                        placeholder="HH:mm"
                        onChange={evt =>
                          handleChangeRecess(evt, position, 'hour')
                        }
                        name-error={`start_${position}`}
                        onBlur={handleBlurRecessHour}
                        ref={register}
                      />
                      {errors[`start_${position}`] &&
                      errors[`start_${position}`].type === 'hour' ? (
                          <ErrorMsgField type="hour" />
                        ) : (
                          <small className="form-text m-0">&nbsp;</small>
                        )}
                    </div>
                    <div className="form-group col-sm-3 mb-0">
                      <label>
                        <i className="far fa-clock" /> Fechamento
                        <span className="field-required">*</span>
                      </label>
                      <InputMask
                        name="end"
                        mask="99:99"
                        value={recess.end}
                        className="form-control input-hour"
                        placeholder="HH:mm"
                        onChange={evt =>
                          handleChangeRecess(evt, position, 'hour')
                        }
                        name-error={`end_${position}`}
                        onBlur={handleBlurRecessHour}
                        ref={register}
                      />
                      {errors[`end_${position}`] &&
                        errors[`end_${position}`].type === 'hour' && (
                        <ErrorMsgField type="hour" />
                      )}
                      {errors[`end_${position}`] &&
                        errors[`end_${position}`].type === 'endHour' && (
                        <ErrorMsgField type="endHour" />
                      )}
                      {(!errors[`end_${position}`] ||
                        (errors[`end_${position}`] &&
                          errors[`end_${position}`].type === '')) && (
                        <small className="form-text m-0">&nbsp;</small>
                      )}
                    </div>
                    <div className="col-sm-2">
                      <button
                        type="button"
                        className="btn btn-danger btn-block btn-remove-recess rounded-0"
                        onClick={() => handleClickRemoveRecess(position)}
                      >
                        <i className="fa fa-trash-alt"></i>
                      </button>
                      <small className="form-text m-0">&nbsp;</small>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <FormFooter url="/expedients" reference={submitButton} />
      </form>
    </div>
  );
}

export default Add;
